import { Box, IconButton } from "@chakra-ui/react"
import React from "react"
import { ReactComponent as CarouselArrow } from "~/images/CarouselArrow.svg"

interface ArrowNavigationProps {
  paginate: (direction: number) => void
}

const CarouselArrowNavigation: React.FC<ArrowNavigationProps> = ({
  paginate,
}) => {
  return (
    <Box className="s_arrow-navigation" display={{ base: "none", md: "block" }}>
      <IconButton
        backgroundColor={"transparent"}
        _hover={{
          backgroundColor: "transparent",
        }}
        _active={{
          backgroundColor: "transparent",
        }}
        className="arrow"
        onClick={() => paginate(-1)}
        aria-label="prev image"
        transform="translateY(-50%) rotate(180deg)"
        pos="absolute"
        top="50%"
        icon={<CarouselArrow />}
        zIndex="2"
        left="0px"
        w="40px"
        h="40px"
        color={"#000"}
      />

      <IconButton
        backgroundColor={"transparent"}
        _hover={{
          backgroundColor: "transparent",
        }}
        _active={{
          backgroundColor: "transparent",
        }}
        className="arrow"
        onClick={() => paginate(1)}
        aria-label="next image"
        pos="absolute"
        top="50%"
        transform="translateY(-50%)"
        icon={<CarouselArrow />}
        zIndex="2"
        right="0px"
        w="40px"
        h="40px"
        color={"#000"}
      />
    </Box>
  )
}

export default CarouselArrowNavigation
